import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProductRange = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Laag_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 18.8 19.1",
	style: { enableBackground: "new 0 0 18.8 19.1" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("filter", {
			id: "Adobe_OpacityMaskFilter",
			filterUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 18.8,
			height: 19.1,
			children: /* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
			})
		}) }),
		/* @__PURE__ */ _jsx("mask", {
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 18.8,
			height: 19.1,
			id: "mask0_308_29133_00000016792728901305112600000015816969086032137106_",
			children: /* @__PURE__ */ _jsx("rect", {
				x: -5.1,
				y: -3.9,
				className: "st0",
				width: 27,
				height: 27
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			className: "st1",
			children: /* @__PURE__ */ _jsx("path", {
				className: "st2",
				d: "M7.3,15.9c-2,0-3.7-0.7-5.2-2.1C0.7,12.3,0,10.6,0,8.6V1.7c0-0.5,0.2-0.9,0.5-1.2S1.2,0,1.7,0h13.6 c1,0,1.8,0.3,2.4,1c0.7,0.7,1,1.5,1,2.4c0,1-0.3,1.8-1,2.4c-0.7,0.7-1.5,1-2.4,1h-0.7v1.6c0,2-0.7,3.7-2.1,5.2 C11.1,15.2,9.3,15.9,7.3,15.9z M1.7,5.2h11.3V1.7H1.7V5.2z M7.3,14.2c1.6,0,2.9-0.5,4-1.6c1.1-1.1,1.6-2.4,1.6-4V6.9H1.7v1.6 c0,1.6,0.5,2.9,1.6,4C4.4,13.6,5.8,14.2,7.3,14.2z M14.6,5.2h0.7c0.5,0,0.9-0.2,1.3-0.5c0.3-0.3,0.5-0.8,0.5-1.3 c0-0.5-0.2-0.9-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5h-0.7V5.2z M0,19.1v-1.7h16.6v1.7H0z",
				fill: "currentColor"
			})
		})
	]
});
export { SvgProductRange as ReactComponent };
